// Author Liang Gang Qiang
// Date 2021-11-10 09:23:07

class MintalMesQualityCompound {
constructor({
        id = null,
        formula = '',
        molecularWeight = '',
        name = '',
        unit = '',
        remark = ''}
= {}) {
    this.id = id;
    this.formula = formula;
    this.molecularWeight = molecularWeight;
    this.name = name;
    this.unit = unit;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesQualityCompound();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.quality.mintalMesQualityCompound.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'formula',
        label: 'label.mintal.quality.mintalMesQualityCompound.grid.formula',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'molecularWeight',
        label: 'label.mintal.quality.mintalMesQualityCompound.grid.molecularWeight',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.mintal.quality.mintalMesQualityCompound.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'unit',
        label: 'label.mintal.quality.mintalMesQualityCompound.grid.unit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualityCompound.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    formulaFilter : '',
    molecularWeightFilter : '',
    nameFilter : '',
    unitFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'formulaFilter',
        label: 'label.mintal.quality.mintalMesQualityCompound.filter.formula',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'molecularWeightFilter',
        label: 'label.mintal.quality.mintalMesQualityCompound.filter.molecularWeight',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.mintal.quality.mintalMesQualityCompound.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'unitFilter',
        label: 'label.mintal.quality.mintalMesQualityCompound.filter.unit',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'formula',
        label: 'label.mintal.quality.mintalMesQualityCompound.entity.formula',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'molecularWeight',
        label: 'label.mintal.quality.mintalMesQualityCompound.entity.molecularWeight',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'name',
        label: 'label.mintal.quality.mintalMesQualityCompound.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'unit',
        label: 'label.mintal.quality.mintalMesQualityCompound.entity.unit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualityCompound.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesQualityCompound, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
